export type AdminTabType =
  | 'users'
  | 'usage'
  | 'billing'
  | 'connector'
  | 'nlt'
  | 'leaderboard'
  | 'fine-tuning-graph';

export interface AdminTabDefinition {
  id: AdminTabType;
  label: string;
  icon: string;
  eyebrow: string;
  description: string;
}

export const ADMIN_TABS: AdminTabDefinition[] = [
  {
    id: 'users',
    label: 'Users',
    icon: 'fa-users',
    eyebrow: 'Accounts',
    description: 'Manage user accounts, roles, and token balances.',
  },
  {
    id: 'usage',
    label: 'Usage',
    icon: 'fa-chart-line',
    eyebrow: 'Aggregates',
    description: 'Per-user token usage summaries and costs.',
  },
  {
    id: 'billing',
    label: 'Billing',
    icon: 'fa-file-invoice-dollar',
    eyebrow: 'History',
    description: 'Detailed per-request usage and billing records.',
  },
  {
    id: 'connector',
    label: 'Connector',
    icon: 'fa-plug',
    eyebrow: 'Integrations',
    description: 'Administer integrations and assign configs to users.',
  },
  {
    id: 'nlt',
    label: 'NLT Configs',
    icon: 'fa-sliders-h',
    eyebrow: 'Templates',
    description: 'Global NLT configuration templates.',
  },
  {
    id: 'leaderboard',
    label: 'Leaderboard',
    icon: 'fa-ranking-star',
    eyebrow: 'Benchmarks',
    description: 'Prompt tuning algorithm leaderboards and meta-datasets.',
  },
  {
    id: 'fine-tuning-graph',
    label: 'FT Graph',
    icon: 'fa-project-diagram',
    eyebrow: 'Lineage',
    description: 'Fine-tuned model lineage and relationships.',
  },
];

export function getAdminTab(id: AdminTabType): AdminTabDefinition {
  return ADMIN_TABS.find((t) => t.id === id) ?? ADMIN_TABS[0];
}

export function resolveAdminTab(pathname: string, search: string): AdminTabType {
  if (pathname === '/admin/fine-tuning-graph') return 'fine-tuning-graph';
  const tab = new URLSearchParams(search).get('tab');
  if (tab === 'usage' || tab === 'billing' || tab === 'connector' || tab === 'nlt' || tab === 'leaderboard') {
    return tab;
  }
  return 'users';
}
